gsap.registerPlugin(ScrollToPlugin);

// Fade Animations for every page
var fadeInElems = gsap.utils.toArray(".fade.fadeIn");
fadeInElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeUpElems = gsap.utils.toArray(".fade.fadeUp");
fadeUpElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        y: 15,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeLeftElems = gsap.utils.toArray(".fade.fadeLeft");
fadeLeftElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: -15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeRightElems = gsap.utils.toArray(".fade.fadeRight");
fadeRightElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: 15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

    // Timeline horizontal scroll

// gsap.registerPlugin(ScrollToPlugin);
let timelineItems = gsap.utils.toArray(".timeline .timeline-scroll-items .timeline-item");

if (timelineItems.length >=1 ) {
    gsap.to(timelineItems, {
        xPercent: -100 * (timelineItems.length - 1),
        ease: "none",
        scrollTrigger: {
            trigger: ".timeline",
            pin: true,
            scrub: 1,
            snap: 1 / (timelineItems.length - 1),
            end: () => "+=" + document.querySelector(".timeline-scroll-items").offsetWidth
        }
    });
}